<template>
  <div class="chat-fab">
    <div @click="navTo" class="icon">💬</div>
  </div>
</template>

<script>
export default {
  name: 'FloatingChat',
  methods: {
    navTo() {
      window.location.href = "https://t.me/Biryuk_Law_Firm"
      // window.location.href = "https://t.me/David_Brady1"
    }
  }
}
</script>

<style scoped>
.chat-fab {
  position: fixed;
  bottom: 88px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: #00ffa3;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #000;
  box-shadow: 0 0 20px rgba(0, 255, 163, 0.7);
  cursor: pointer;
  z-index: 999;
}
</style>